<template>
  <div>
    <!-- banner -->
    <section>
      <div class="banner-wrapper">
        <picture>
          <source
            media="(min-width: 1060px)"
            srcset="@/assets/images/desktop/privacy/banner.svg"
          />
          <img
            class="banner-picture"
            src="@/assets/images/mobile/privacy/banner.svg"
            alt="藍第一頻"
          />
        </picture>
        <div class="title-wrapper">
          <p class="title-c-privacy">隱私權政策</p>
          <p class="title-e-privacy">Privacy Policy</p>
        </div>
      </div>
    </section>

    <section>
      <div class="gray-area-privacy">
        <div class="white-area-privacy">
          <p>
            代買幫網站服務是由代買幫商行（以下簡稱「本公司」）所提供之服務，為了讓您能夠安心的使用本網站所提供的服務，謹藉由此隱私權保護聲明，讓您清楚了解本網站如何蒐集、應用、處理及保護您在本網站上所提供的個人基本數據。
            <br />
            <br />
            除非您自願提供，否則本公司不會藉本平台來蒐集您的個人基本資料。當您於網頁中填寫您個人基本資料時，即表示您同意本公司可根據此隱私權保護聲明所載明的方式，來進行您個人基本數據的收集、儲存與運用。您瀏覽及使用本網頁行為視為您同意本聲明內容。
          </p>

          <div class="context-privacy">一、適用範圍</div>
          <p>本網站於提供服務之際所取得之用戶相關資訊，主要例示如下：</p>
          <ol class="custom-list">
            <li>
              用戶主動提供之資訊：包含姓名、地址、聯絡電話、手機號碼、郵件信箱、生日、性別、身分證字號、銀行帳號、其他聯絡方式、相關資訊等客戶向本網站提供之一切數據。
            </li>
            <li>因利用服務所取得之資訊</li>
            <p class="list-paragraph">
              •
              使用者對本網站或服務提供商提供之商品或勞務，為下標、購買、參加贈獎活動或申請其他交易時之客戶識別資訊及其相對應之事務歷史記錄資訊。
            </p>
            <p class="list-paragraph">• 獲得活動券、贈品等之相關資訊。</p>
            <p class="list-paragraph">
              •
              以電話、電子郵件或其他方法，向本網站或服務提供商提出問題、參加網站活動、利用留言版、或進行服務評價時，其發言或記載內容之相關資訊。
            </p>
            <li>因瀏覽頁面而自動取得之資訊</li>
            <p class="list-paragraph">
              • 客戶電腦上網時之IP地址、手機端之機體識別之相關資訊。
            </p>
            <p class="list-paragraph">
              •
              於客戶進入本網站經營之網頁時，自動取得之客戶瀏覽器種類、版本、操作系統、平台等資訊之外，客戶瀏覽之網頁（URL）、瀏覽時間、輸入或檢索之商品等相關資訊。
            </p>
          </ol>
          <br />
          <p>
            上述之外，因使用者在註冊帳號、瀏覽網頁、參加網站上相關活動或使用者要求加入會員、使用電子郵件服務或其他服務時，本公司會取得蒐集個人識別數據，
            也會自動記錄接收用戶上站的地址、瀏覽器上的伺服器數值、使用 cookie或
            web beacon
            技術所取得之瀏覽資訊、網頁紀錄以及相關數據等，但是這些數據僅供作網路使用分析和網路行為調查，以便改進網站的整體服務品質，並不會因而和使用者產生特定關聯或識別性。在某些情況下，本公司網站或其合作對象可能會要求用戶登錄個人識別數據，以便於和用戶完成交易及提供服務。
          </p>

          <div class="context-privacy">二、資訊使用</div>
          <p>
            本公司於營運期間，會員之個人資料檔案，除用於本公司之會員管理、客戶管理之檢索查詢等功能外，將有以下利用：
          </p>
          <ol class="custom-list">
            <li>
              客戶以本網站會員身份而利用服務之情形：已登錄本網站服務之會員利用服務時，於登入或登入後之本人認證及各種頁面中自動顯示之會員資訊。
            </li>
            <li>
              為執行本網站所提供之交易：客戶對商品預約、下標、購買、參與贈獎等活動或從事其他交易時，關於商品配送、價金給付等相關服務及其他交易所必要之業務。
            </li>
            <li>
              回覆客戶之詢問：針對客戶透過電子郵件、郵件、電話等方式向本網站所提出之詢問進行回覆。
            </li>
            <li>
              金融交易及授權：消費者所提供之財務相關資訊，將於金融交易過程（如信用卡授權、轉帳）時提交給金融機構以完成金融交易。
            </li>
            <li>
              為服務用戶的目的，本網站可能通過使用您的個人資訊，向您提供您感興趣的資訊，包括但不限於向您發出產品和服務資訊。
            </li>
            <li>
              當本站要與合作夥伴共享會員資訊時，需要經過會員的事先同意，本站才會向會員發送有關其產品和服務的資訊。
            </li>
            <li>
              本網站不會向任何無關第三方提供、出售、出租、分享或交易您的個人資訊，除非事先得到您的許可，或該第三方單獨或共同為您提供服務，且在該服務結束後，其將被禁止訪問包括其以前能夠訪問的所有這些資料。
            </li>
            <li>
              本網站亦不允許任何第三方以任何手段收集、編輯、出售或者無償傳播您的個人資訊。任何本網站用戶如從事上述活動，一經發現，本網站有權立即終止與該用戶的服務協議。
            </li>
          </ol>

          <div class="context-privacy">三、資訊披露</div>
          <p>
            在如下情況下，本網站將依據的會員個人意願或法律的規定全部或部分的披露會員的個人資訊：
          </p>
          <ol class="custom-list">
            <li>經會員事先同意，向第三方披露；</li>
            <li>
              如會員是合格的知識產權投訴人並已提起投訴，應被投訴人要求，向被投訴人披露，以便雙方處理可能的權利糾紛；
            </li>
            <li>
              根據法律的有關規定，或者行政或司法機構的要求，向第三方或者行政、司法機構披露；
            </li>
            <li>
              如您出現違反台灣有關法律、法規或者本網站服務協議或相關規則的情況，需要向第三方披露；
            </li>
            <li>
              為提供您所要求的產品和服務，而必須和第三方分享會員的個人資訊；
            </li>
            <li>
              在本網站上創建的某一交易中，如交易任何一方履行或部分履行了交易義務並提出資訊披露請求的，本網站有權決定向該用戶提供其交易對方的聯絡方式等必要資訊，以促成交易的完成或糾紛的解決。
            </li>
            <li>其它本網站根據法律、法規或者網站政策認為合適的披露。</li>
          </ol>

          <div class="context-privacy">四、資訊存儲和交換</div>
          <p>
            本網站收集的有關您的資訊和資料將保存在本網站及（或）其關聯公司的伺服器上，這些資訊和資料可能傳送至您所在國家、地區或本網站收集資訊和資料所在地的境外並在境外被訪問、存儲和展示。
          </p>

          <div class="context-privacy">五、Cookie的使用</div>
          <ol class="custom-list">
            <li>
              在您未拒絕接受cookies的情況下，本網站會在您的電腦上設定或取用cookies，以便您能登錄或使用依賴於cookies的本網站服務或功能。本網站使用cookies可為您提供更加周到的個性化服務，包括推廣服務。
            </li>
            <li>
              您有權選擇接受或拒絕接受cookies。您可以通過修改瀏覽器設置的方式拒絕接受cookies。但如果您選擇拒絕接受cookies，則您可能無法登錄或使用依賴於cookies的本網站服務或功能。
            </li>
            <li>通過本網站所設cookies所取得的有關資訊，將適用本政策。</li>
          </ol>

          <div class="context-privacy">六、資訊安全</div>
          <ol class="custom-list">
            <li>
              為保障您的隱私及安全，您的本網站會員帳號數據會進行加密保護。本網站會以合理之技術、程序及安全措施確保您的資訊不丟失，不被濫用和變造。儘管有前述安全措施，但同時也請您注意在資訊網路上不存在"完善的安全措施"。
            </li>
            <li>
              在使用本公司服務進行網上交易時，您不可避免的要向交易對方或潛在的交易對方披露自己的個人資訊，如聯絡方式或者郵政地址。請您妥善保護自己的個人資訊，僅在必要的情形下向他人提供。如您發現自己的個人資訊洩密，尤其是你的帳戶及密碼發生洩露，請您立即聯絡本公司客服，以便本公司採取相應措施。
            </li>
          </ol>

          <div class="context-privacy">七、隱私權保護政策修訂</div>
          <p>
            本公司可不時修訂本政策。當個人資料的相關處理上有變更時，將會主動在本公司的社群平台上告示。
          </p>
          <div class="context-privacy">八、問題和建議</div>
          <p>如果您有任何問題或建議，請透過客服與我們聯繫。</p>

          <br />
          <p>更新日期：2024.06.04</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script></script>

<style scoped>
/* Banner - Mobile First */
.banner-wrapper {
  overflow: hidden;
  position: relative;
}

.banner-picture {
  width: 200%;
  position: relative;
  transform: translateX(-20%);
}

.title-wrapper {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  text-align: center;
}

.title-c-privacy {
  font-weight: 500;
  font-size: 26px;
  color: #ffffff;
  position: absolute;
  top: 13vw;
  transform: translateX(-50%);
  left: 50%;
  letter-spacing: 3px;
}

.title-e-privacy {
  font-weight: 500;
  font-size: 24px;
  color: #ffffff;
  position: absolute;
  top: 22.5vw;
  transform: translateX(-50%);
  left: 50%;
  letter-spacing: 0.5px;
  white-space: nowrap;
}

/* 針對 iPad Pro 10.5" */
@media (min-width: 834px) and (max-width: 1059px) {
  .banner-picture {
    height: 250px;
    transform: translateX(-25%);
  }

  .title-c-privacy {
    top: 11vw;
    font-size: 32px;
  }

  .title-e-privacy {
    top: 16vw;
    font-size: 28px;
  }
}

/* Desktop */
@media (min-width: 1060px) {
  .banner-picture {
    width: 100%;
    height: auto;
    transform: none;
  }

  .title-c-privacy {
    font-weight: 500;
    font-size: clamp(32px, 2.77vw, 40px);
    top: 12vw;
    letter-spacing: 3px;
  }

  .title-e-privacy {
    font-weight: 400;
    font-size: clamp(26px, 2.22vw, 32px);
    top: 16.5vw;
    letter-spacing: 0.5px;
  }
}

/* Content Area - Mobile First */
.gray-area-privacy {
  background: #f8f9fa;
  width: 100%;
  padding-top: 31px;
  padding-bottom: 80px;
}

.white-area-privacy {
  width: 343px;
  background: #ffffff;
  padding: 30px;
  border-radius: 15px;
  margin: 0 auto;
  box-shadow: 0.5px 0.5px 20px 1px #dee2e6;
}

.context-privacy {
  font-weight: 600;
  font-size: 20px;
  color: #212529;
  margin-top: 48px;
  margin-bottom: 32px;
}

.white-area-privacy p {
  font-size: 15px;
  line-height: 30px;
  letter-spacing: 0.5px;
  color: #495057;
}

/* Desktop Content */
@media (min-width: 1060px) {
  .gray-area-privacy {
    padding-top: 40px;
    padding-bottom: 100px;
  }

  .white-area-privacy {
    width: 1220px;
    padding: 60px;
  }

  .context-privacy {
    font-size: 28px;
    margin-top: 40px;
    margin-bottom: 20px;
  }

  .white-area-privacy p {
    font-size: 16px;
  }
}

/* List Styles - Mobile First */
.custom-list li {
  text-indent: -1em;
  padding-left: 1em;
  font-size: 15px;
  line-height: 30px;
  letter-spacing: 0.5px;
  color: #495057;
}

.custom-list {
  list-style-position: inside;
  padding-left: 0;
}

.custom-list li {
  position: relative;
  margin-left: 1em;
  padding-left: 0.5em;
}

.custom-list li::before {
  counter-increment: item;
  position: absolute;
  left: -1.5em;
}

.list-paragraph {
  text-indent: -1em;
  padding-left: 2em;
  margin-left: 1em;
  margin-top: 0.2em;
  margin-bottom: 0.2em;
}

/* Desktop List */
@media (min-width: 1060px) {
  .custom-list li {
    font-size: 16px;
  }
}
</style>
